"use client";

import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faCogs, faCloudUploadAlt, faChartLine } from "@fortawesome/free-solid-svg-icons";
import styles from "./HowWeWork.module.css";

const steps = [
  {
    icon: faSearch,
    title: "Understand your needs",
    desc: "Every setup begins with a deep understanding of your goals, workload, and performance requirements.",
  },
  {
    icon: faCogs,
    title: "Design the perfect infrastructure",
    desc: "Our engineers tailor solutions for speed, security, and scalability.",
  },
  {
    icon: faCloudUploadAlt,
    title: "Deploy & manage everything",
    desc: "From setup to optimization to ongoing maintenance — we take care of the entire lifecycle.",
  },
  {
    icon: faChartLine,
    title: "Guide your growth",
    desc: "As your project expands, we help upgrade, customize, and optimize your infrastructure seamlessly.",
  },
];

const HowWeWork = () => {
  return (
    <section className={styles.sectionSpace}>
      <Container>
        {/* Main Heading */}
        <div className="text-center mb-5">
          <h2 className={styles.mainHeading}>How We Work ?</h2>
          <p className={styles.mainDesc}>
            Temok follows a simple, client-first approach.
          </p>
        </div>

        <Row className="g-4 justify-content-center">
          {steps.map((item, index) => (
            <Col md={6} lg={3} key={index}>
              <div className={styles.cardBox}>

                {/* Icon */}
                <div className={styles.iconCircle}>
                  <FontAwesomeIcon icon={item.icon} />
                </div>

                <h5 className={styles.title}>{item.title}</h5>
                <p className={styles.desc}>{item.desc}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default HowWeWork;
